export const MODULE = "sales-order-invoicing-ftue";
